import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  /* istanbul ignore next */
  setLocation(href: string) {
    window.location.href = href;
  }

  setScrollPositionOfElement(element: HTMLElement, x: number, y: number) {
    element.scrollTo(x, y);
  }
}
